<ald-header [isWelcome]="isNotLogged()"></ald-header>
<section class="main-div">
  <mat-card class="mt-1 half-width image mat-custom-card mat-custom-card-shadow">
    <div class="mb-1 flex flex-col justify-center items-center gap-[2em]">
      <img [src]="loadImage()" alt="" [ngClass]="getClassForImageRender()" />
      <button *ngIf="isNotLogged()" mat-raised-button color="primary" class="mt-1 quarter-width" (click)="login()">
        Login
      </button>
    </div>
  </mat-card>
</section>